export { createPalette } from "@alethio/ui/lib/theme/createPalette";
